import { Flex, Text } from '@chakra-ui/react';
import {
  faEnvelope,
  faExclamationTriangle
} from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Modal } from '@morressier/alembic';
import { Overlay } from 'src/components/Overlay';

export const ConfirmExitModal = ({
  onClose,
  onConfirm
}: {
  onClose: () => void;
  onConfirm: () => void;
}) => {
  return (
    <Overlay>
      <Modal isOpen onClose={onClose} width="448px">
        <Flex
          flexDirection="column"
          alignItems="flex-start"
          gap={4}
          padding={8}
        >
          <Flex color="actionSecondaryCautionContent">
            <FontAwesomeIcon size="2x" icon={faExclamationTriangle} />
          </Flex>

          <Flex flexDirection="column" gap={2}>
            <Text textStyle="headingGroup">Exit Without Finishing?</Text>
            <Text>
              You are about to leave this page – you will be able to still review
              this Submission on your own. Are you sure you want to continue?
            </Text>
          </Flex>
          <Flex justifyContent="flex-end" gap={2} width="100%">
            <Button variant="secondary" onClick={onClose}>
              Cancel
            </Button>
            <Button variant="caution" onClick={onConfirm}>
              Exit
            </Button>
          </Flex>
        </Flex>
      </Modal>
    </Overlay>
  );
};
export const ConfirmInvitationModal = ({
  onClose,
  onConfirm,
  email
}: {
  email: string;
  onClose: () => void;
  onConfirm: () => void;
}) => {
  return (
    <Overlay>
      <Modal isOpen onClose={onClose} width="448px">
        <Flex
          flexDirection="column"
          alignItems="flex-start"
          gap={4}
          padding={8}
        >
          <FontAwesomeIcon size="2x" icon={faEnvelope} />

          <Flex flexDirection="column" gap={2}>
            <Text textStyle="headingGroup">Confirm Invitation</Text>
            <Text>
              {email} will receive an email invitation to Co-Review. You cannot
              modify the invitation after sending.
            </Text>
            <Text>
              If this Co-Reviewer declines your invitation, you can still
              continue with the review.
            </Text>
          </Flex>
          <Flex justifyContent="flex-end" gap={2} width="100%">
            <Button variant="secondary" onClick={onClose}>
              Cancel
            </Button>
            <Button variant="primary" onClick={onConfirm}>
              Invite Co-Reviewer
            </Button>
          </Flex>
        </Flex>
      </Modal>
    </Overlay>
  );
};
